var map = {
	"./alberta.png": "bhF8",
	"./bc.png": "ax0X",
	"./manitoba.png": "rO3r",
	"./new-brunswick.png": "bIfX",
	"./newfoundland-and-labrador.png": "iDzA",
	"./nova-scotia.png": "sPsc",
	"./ontario.png": "gkdv",
	"./pei.png": "GShP",
	"./quebec.png": "IcHW",
	"./saskatchewan.png": "fBtB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yLXY";